import { ImageLayoutSize } from '@xcel-next/core/enums'

export default {
  article: {
    header: { menu: [] },
    body: {
      roofline: 'Artikel-Roofline',
      headline: 'Artikel-Headline',
      introductionText: '<p>Introduction-Text</p>',
      paragraphs: [
        {
          paragraphType: 'image',
          image: {
            imageCredit: 'Bildnachweis',
            width: 1600,
            height: 900,
            layout: {
              size: ImageLayoutSize.l
            },
            imageDescription: {
              html: '<p>Bildunterschrift</p>'
            }
          }
        },
        {
          paragraphType: 'text',
          text: '<p>Artikeltext</p>'
        },
        {
          paragraphType: 'horizontalLine',
          horizontalLine: {
            lineTitle: 'MEHR ZUM THEMA'
          }
        },
        {
          paragraphType: 'teaserGroup',
          teaserGroup: {
            teaserGroupType: 'bx-teaser-container--one-third-width',
            teasers: [
              {
                imageId: '83f993e0',
                titleLong: 'Teaser-Headline',
                textLong: 'Teaser-Copytext',
                advertorial: true,
                roofline: 'Teaser-Roofline',
                url: '#'
              }
            ]
          }
        },
        {
          paragraphType: 'adaAutoNative'
        }
      ]
    },
    footer: {},
    pageMeta: {
      pageType: 'article'
    },
    metaData: {
      adaAutoNative: true,
      advertorial: true,
      noIndex: true
    }
  },
  structureterm: {
    header: { menu: [] },
    body: {
      paragraphs: [
        {
          paragraphType: 'teaserGroup',
          teaserGroup: {
            teaserGroupType: 'bx-teaser-container--one-third-width',
            teasers: [
              {
                imageId: '83f993e0',
                titleLong: 'Teaser-Headline',
                textLong: 'Teaser-Copytext',
                advertorial: true,
                roofline: 'Teaser-Roofline',
                url: '#'
              }
            ]
          }
        },
        {
          paragraphType: 'adaAutoNative'
        }
      ]
    },
    footer: {},
    pageMeta: {
      pageType: 'structureterm'
    },
    metaData: {
      adaAutoNative: true,
      advertorial: true,
      noIndex: true
    }
  },
  pagestrip: {
    header: { menu: [] },
    body: {
      paragraphs: [
        {
          paragraphType: 'adaPagestrip'
        }
      ]
    },
    footer: {},
    pageMeta: {
      pageType: 'structureterm'
    },
    metaData: {
      adaAutoNative: true,
      advertorial: true,
      noIndex: true
    }
  }
}
